/**
 * 本地存储封装
 * 替代uni.getStorageSync/uni.setStorageSync
 */

class Storage {
  /**
   * 设置存储
   * @param {string} key - 存储键名
   * @param {any} value - 存储值
   */
  set(key, value) {
    try {
      const data = JSON.stringify(value)
      localStorage.setItem(key, data)
      return true
    } catch (error) {
      console.error('Storage set error:', error)
      return false
    }
  }

  /**
   * 获取存储
   * @param {string} key - 存储键名
   * @param {any} defaultValue - 默认值
   */
  get(key, defaultValue = null) {
    try {
      const data = localStorage.getItem(key)
      // Handle null, undefined, or "undefined" string
      if (data === null || data === undefined || data === 'undefined') {
        return defaultValue
      }
      return JSON.parse(data)
    } catch (error) {
      console.error('Storage get error:', error)
      // Clear corrupted data
      localStorage.removeItem(key)
      return defaultValue
    }
  }

  /**
   * 移除存储
   * @param {string} key - 存储键名
   */
  remove(key) {
    try {
      localStorage.removeItem(key)
      return true
    } catch (error) {
      console.error('Storage remove error:', error)
      return false
    }
  }

  /**
   * 清空所有存储
   */
  clear() {
    try {
      localStorage.clear()
      return true
    } catch (error) {
      console.error('Storage clear error:', error)
      return false
    }
  }

  /**
   * 获取所有存储的键
   */
  keys() {
    try {
      const keys = []
      for (let i = 0; i < localStorage.length; i++) {
        keys.push(localStorage.key(i))
      }
      return keys
    } catch (error) {
      console.error('Storage keys error:', error)
      return []
    }
  }

  /**
   * 判断是否存在某个键
   * @param {string} key - 存储键名
   */
  has(key) {
    return localStorage.getItem(key) !== null
  }

  /**
   * 获取存储大小（仅估算）
   */
  size() {
    let totalSize = 0
    for (let key in localStorage) {
      if (localStorage.hasOwnProperty(key)) {
        totalSize += localStorage[key].length + key.length
      }
    }
    return totalSize
  }
}

// 创建单例
const storage = new Storage()

// 兼容uni-app的API命名
export const getStorageSync = (key, defaultValue) => storage.get(key, defaultValue)
export const setStorageSync = (key, value) => storage.set(key, value)
export const removeStorageSync = (key) => storage.remove(key)
export const clearStorageSync = () => storage.clear()

export default storage